/**
 * seitenCache – merkt sich Antworten im Browser, damit die Startseite beim
 * Neuladen sofort etwas zeigt.
 *
 * Muster: erst das Gemerkte anzeigen, dann im Hintergrund neu holen und
 * ersetzen ("stale-while-revalidate"). Der Nutzer sieht also nie eine leere
 * Karte, auch wenn der Abruf hinten ein paar Sekunden braucht.
 *
 * Gespeichert wird in localStorage — das überlebt auch einen Browser-Neustart.
 */

const PRAEFIX = "imho.cache.";

/** Gemerkte Daten lesen. Zu alte Einträge werden verworfen. */
export function cacheLesen(schluessel, maxAlterSekunden = 3600) {
  try {
    const roh = localStorage.getItem(PRAEFIX + schluessel);
    if (!roh) return null;
    const { zeit, daten } = JSON.parse(roh);
    if (!zeit || (Date.now() - zeit) / 1000 > maxAlterSekunden) {
      localStorage.removeItem(PRAEFIX + schluessel);
      return null;
    }
    return daten;
  } catch {
    return null;
  }
}

/** Daten merken. Schlägt das fehl (z.B. Speicher voll), passiert nichts. */
export function cacheSchreiben(schluessel, daten) {
  try {
    localStorage.setItem(
      PRAEFIX + schluessel,
      JSON.stringify({ zeit: Date.now(), daten })
    );
  } catch {
    /* Speicher voll oder gesperrt — dann eben ohne Cache */
  }
}

export function cacheLeeren(schluessel) {
  try {
    localStorage.removeItem(PRAEFIX + schluessel);
  } catch {
    /* egal */
  }
}
